import Facilities from './Facilities'

export default Facilities
